import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import React, {useState, useEffect} from 'react';

const Delayed = (props) => {
  const {children, waitBeforeShow, dependency = []} = props;

  const [isShown, setIsShown] = useState(false);

  useEffect(() => {
    setIsShown(false);
    setTimeout(() => {
      setIsShown(true);
    }, waitBeforeShow);
  }, [waitBeforeShow, ...dependency]);

  return isShown ? children : <Skeleton variant="rect" height={'100%'} animation="wave" />;
};
Delayed.defaultProps = {
  waitBeforeShow: 500,
  dependency: [],
};

Delayed.propTypes = {
  waitBeforeShow: PropTypes.number.isRequired,
  dependency: PropTypes.array.isRequired,
};

export default Delayed;
